import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {LicensePlateTo} from './license-plate-to';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LicensePlateService {

  baseUrl = `${environment.baseUrl}/license-plate`;

  constructor(private httpClient: HttpClient) {
  }

  getLicensePlate(licensePlate: string): Observable<LicensePlateTo> {
    return this.httpClient.get<LicensePlateTo>(`${this.baseUrl}/${licensePlate}/vin`);
  }

  getLicensePlateByVin(vin: string): Observable<LicensePlateTo> {
    return this.httpClient.get<LicensePlateTo>(`${this.baseUrl}/${vin}`);
  }
}
